export default __webpack_public_path__ + "static/media/mobile.c66dfb9f.png";